import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Link, Link as RouterLink, useNavigate } from 'react-router-dom';
import { useActions } from '../../../hooks/useAction';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Container, Avatar, Typography, TextField, Button, Box } from '@mui/material';
import { useTypedSelector } from '../../../hooks/useTypesSelector';
import { LoadingButton } from '@mui/lab';
import { RegisterSchema } from '../helpers/yup';

export const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { loading, isAuthorized } = useTypedSelector((state) => state.auth);
  const { register } = useActions();

  useEffect(() => {
    if (isAuthorized) {
      navigate('/');
    }
  }, [isAuthorized, navigate]);

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: (values) => {
      register(values);
    },
  });

  return (
    <Box>
      <Container maxWidth="xs">
        <Box
          sx={{
            paddingTop: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" textAlign="center">
            Создайте акканут Lingway
          </Typography>
          <Box component="form" onSubmit={formik.handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Почта"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="name"
              label="Имя пользователя"
              name="name"
              autoComplete="name"
              onChange={formik.handleChange}
              autoFocus
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Пароль"
              type="password"
              onChange={formik.handleChange}
              id="password"
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              autoComplete="current-password"
            />
            {loading ? (
              <LoadingButton size="large" variant="contained" loading={loading} fullWidth={true}>
                Зарегистрироваться
              </LoadingButton>
            ) : (
              <Button
                type="submit"
                variant="contained"
                fullWidth={true}
                disableElevation={true}
                sx={{
                  marginTop: 1,
                  marginBottom: 1,
                }}
              >
                Зарегистрироваться
              </Button>
            )}
            <Box sx={{ display: 'inline-flex', alignItems: 'baseline' }}>
              <Typography>У вас уже есть аккаунт? </Typography>
              <Button component={RouterLink} to="/login" variant="text">
                Авторизоваться
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
